import { useTranslation } from 'react-i18next';
import { ErrorResultA11y } from './ErrorResultA11y.tsx';
import { type IErrorResultBodyProps } from './ErrorResultBody.tsx';
import { OnPageResultContainer } from './OnPageResultContainer.tsx';

/**
 * Props condivise tra i componenti di errore.
 */
export function ForbiddenBody(props: IErrorResultBodyProps) {
  const { message, description, title } = props;
  const { t } = useTranslation();

  return (
    <OnPageResultContainer>
      <ErrorResultA11y
        status="error"
        title={title ?? t('alert.forbidden-body.title', '403 Non Autorizzato')}
        subTitle={
          message ??
          t(
            'alert.forbidden-body.message',
            'Non si dispone dei permessi per visualizzare la pagina richiesta.',
          )
        }
        extra={description}
      />
    </OnPageResultContainer>
  );
}
